import { Component, OnInit } from '@angular/core';
import { APP_IN_MAINTENANCE_KEY, NETWORK_ISSUE_MESSAGE, SESSION_IDLE_URL_KEY } from '../shared/constants';
import { FacadeService } from '../shared/service-facade/facade.service';
import {CoreService} from "../shared/services/core.service";

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {
  message = "";
  closeUrl = "";

  constructor(
    private facadeService: FacadeService,
    private coreService: CoreService
  ) { }

  ngOnInit(): void {
    this.coreService.isDataLoaded.next(true);

    this.closeUrl = this.facadeService.getStorageItem(SESSION_IDLE_URL_KEY);
    this.message = this.facadeService.getStorageItem(APP_IN_MAINTENANCE_KEY);

    if (!this.message) {
      this.message = NETWORK_ISSUE_MESSAGE;
    }
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }
}
